import axios from 'axios';

function authHeaders() {
  const token = localStorage.getItem('accessToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export type AdminShiftRow = {
  id: number;
  tenantName: string;
  userName?: string;
  roleKey?: string;
  startTime: string;
  endTime: string;
  status?: string;
};

export async function fetchShiftsMonitor(params: { tenantId?: number; date?: string; role?: string; page?: number; size?: number; }): Promise<{ content: AdminShiftRow[]; totalElements: number; }>{
  // Backend placeholder: reuse scheduling endpoints per-tenant if no admin API; for now, return empty list to wire UI
  const res = await axios.get('/api/v1/super/shifts', { params, headers: authHeaders() }).catch(()=> ({ data: { content: [], totalElements: 0 } }));
  return res.data || { content: [], totalElements: 0 };
}


